module.exports = __webpack_public_path__ + "static/media/sample_web_app.2185dcff.png";